import { Box, Link, Typography } from '@ace-clublabs/shared-component-library';
import { useGlobalState } from '../../state/state';

export const SelectMembershipDisclaimer = () => {
  const [membershipDetails] = useGlobalState('memberDetails');

  const { clubCode } = membershipDetails;

  const renderUI = () => {
    switch (clubCode) {
      case '004':
        return <CASelectMembershipDisclaimer />;
      case '215':
        return <ECSelectMembershipDisclaimer />;
      case '065':
        return <ACMOSelectMembershipDisclaimer />;
      case '252':
        return <TXSelectMembershipDisclaimer />;
      default:
        return <></>;
    }
  };

  return (
    <Box className="select-membership-disclaimer" marginTop="1.5rem">
      {renderUI()}
    </Box>
  );
};

const ECSelectMembershipDisclaimer = () => (
  <Box
    sx={{
      marginBottom: '2rem',
    }}
  >
    <Typography
      variant="b2Regular"
      sx={{ maxWidth: '1024px !important', whiteSpace: 'pre-line' }}
      className="select-membership-disclaimer-ec"
    >
      Extended Roadside Assistance services for Plus®, Plus® RV, Premier®, or Premier® RV benefit levels, where
      available, and certain Premier® benefits, are effective seven (7) calendar days after processing, and receipt of
      the full payment due. <br />
      <br />
      Auto pay is required to join online and is always required for the monthly dues option. See{' '}
      <Link variant="b2Regular" target="_blank" href="https://app.ace.aaa.com/payments/termsandconditions?variant=mmp">
        Terms and Conditions.
      </Link>{' '}
      If you are purchasing a membership with the annual dues option and do not want to enroll in auto pay, please call
      us at 1-888-703-0678 or visit a branch to purchase a membership with an agent. You may cancel auto pay at any time
      from your My Account page. <br />
      <br />
      Discounted offers do not apply to any former members who previously had Monthly Dues Option.
      <br />
      <br />
      Every membership year, you are allowed up to four (4) free calls per member for Roadside Assistance. After that, a
      service charge applies. Classic benefits include free towing up to three (3) miles from the point of breakdown or
      unlimited miles back to the facility providing the tow. Service is generally provided by independent service
      providers and is limited to the U.S. and Canada. Certain conditions and limitations apply. See the Member Guide
      for more information.
      <br />
      <br />
      Membership eligibility, dues, fees, benefits, and services are subject to change without notice. An individual may
      have only one membership. All applications and renewals are subject to approval and acceptance by the AAA East
      Central. Membership includes a nondeductible $1 subscription for AAA Motorist publication. Each returned payment
      is subject to a returned payment fee, which may be debited electronically. For fee amount visit{' '}
      <Link
        variant="b2Regular"
        target="_blank"
        href="https://www.ace.aaa.com/membership/my-membership/membership-faq.html?area=vanity_servicefee&devicecd=PC#faqServiceFees"
      >
        AAA.com/servicefee.
      </Link>
    </Typography>
  </Box>
);

const CASelectMembershipDisclaimer = () => (
  <Box
    sx={{
      marginBottom: '2rem',
    }}
  >
    <Typography
      variant="b2Regular"
      sx={{ maxWidth: '1024px !important', whiteSpace: 'pre-line' }}
      className="select-membership-disclaimer-ca"
    >
      <strong>
        Extended Roadside Assistance services for Plus®, Plus® RV, Premier® or Premier® RV benefit levels, where
        available, and certain Premier® benefits, are effective seven (7) calendar days after processing, and receipt of
        the full payment due.
      </strong>
      <br />
      <br />
      Every membership year, you are allowed up to four (4) free calls per member for Roadside Assistance. After that, a
      service charge applies. Classic benefits include free towing up to seven (7) miles from the point of breakdown or
      unlimited miles back to the facility providing the tow. Service is provided by independent service providers and
      is limited to the U.S. and Canada. Certain conditions and limitations apply. See the Member Guide for more
      information.
      <br />
      <br />
      Membership eligibility, dues, fees, benefits and services are subject to change without notice. An individual may
      have only one membership. All applications and renewals are subject to approval and acceptance by the Automobile
      Club of Southern California. Membership includes a non-deductible $2 subscription for Westway, Orange County
      Westways or San Diego Westways magazine. Each returned payment is subject to a returned payment fee, which may be
      debited electronically. For fee amount visit{' '}
      <Link
        variant="b2Regular"
        target="_blank"
        href="https://www.ace.aaa.com/membership/my-membership/membership-faq.html?area=vanity_servicefee&devicecd=PC#faqServiceFees"
      >
        AAA.com/servicefee.
      </Link>
    </Typography>
  </Box>
);

const ACMOSelectMembershipDisclaimer = () => (
  <Box
    sx={{
      marginBottom: '2rem',
    }}
  >
    <Typography
      variant="b2Regular"
      sx={{ maxWidth: '1024px !important', whiteSpace: 'pre-line' }}
      className="select-membership-disclaimer-acmo"
    >
      <strong>
        Extended Roadside Assistance services for Plus®, Plus® RV, Premier® or Premier® RV benefit levels, where
        available, and certain Premier® benefits, are effective seven (7) calendar days after processing, and receipt of
        the full payment due.
      </strong>
      <br />
      <br />
      Personal Notary Service is not available in Louisiana.
      <br />
      <br />
      Every membership year, you are allowed up to four (4) free calls per member for Roadside Assistance. After that, a
      service charge applies. Classic benefits include free towing up to three (3) miles from the point of breakdown or
      unlimited miles back to the facility providing the tow. Service is generally provided by independent service
      providers and is limited to the U.S. and Canada. Certain conditions and limitations apply. See the Member Guide
      for more information.
      <br />
      <br />
      Membership eligibility, dues, fees, benefits, and services are subject to change without notice. An individual may
      have only one membership. All applications and renewals are subject to approval and acceptance by AAA Membership.
      Membership includes a non-deductible $3 subscription for AAA Explorer magazine. Each returned payment is subject
      to a returned payment fee, which may be debited electronically. For fee amount visit{' '}
      <Link
        variant="b2Regular"
        target="_blank"
        href="https://www.ace.aaa.com/membership/my-membership/membership-faq.html?area=vanity_servicefee&devicecd=PC#faqServiceFees"
        sx={{ textDecoration: 'none' }}
      >
        AAA.com/servicefee
      </Link>
      .
    </Typography>
  </Box>
);

const TXSelectMembershipDisclaimer = () => (
  <Box
    sx={{
      marginBottom: '2rem',
    }}
  >
    <Typography
      variant="b2Regular"
      sx={{ maxWidth: '1024px !important', whiteSpace: 'pre-line' }}
      className="select-membership-disclaimer-tx"
    >
      <strong>
        Extended Roadside Assistance services for Plus®, Plus® RV, Premier®, or Premier® RV benefit levels, where
        available, and certain Premier® benefits, are effective seven (7) calendar days after processing, and receipt of
        the full payment due.
        <br />
      </strong>
      <br />
      <strong>
        Auto pay is always required for the monthly dues option. See{' '}
        <Link
          variant="b2Bold"
          target="_blank"
          className="autopay-terms-link"
          href="https://app.ace.aaa.com/payments/termsandconditions?variant=mmp"
          sx={{ textDecoration: 'none' }}
        >
          Terms and Conditions
        </Link>
        . You may cancel auto pay at any time from your My Account page.
      </strong>{' '}
      <br />
      <br />
      Discounted offers do not apply to any former members who previously had Monthly Dues Option.
      <br />
      <br />
      The Primary member is allowed up to four (4), and each Adult or Dependent Associate member is allowed up to two
      (2), Roadside Assistance calls, per membership year. After that, a service charge applies. Classic benefits
      include free towing up to seven (7) miles from the point of breakdown or unlimited miles back to the facility
      providing the tow. Service is generally provided by independent service providers and is limited to the U.S. and
      Canada. Certain conditions and limitations apply. See the Member Guide for more information.
      <br />
      <br />
      Membership eligibility, dues, fees, benefits, and services are subject to change without notice. An individual may
      have only one membership. All applications and renewals are subject to approval and acceptance by AAA Texas.
      Membership includes a non-deductible $2 subscription for AAA Explorer. Each returned payment is subject to a
      returned payment fee, which may be debited electronically. For fee amount visit{' '}
      <Link
        variant="b2Regular"
        target="_blank"
        href="https://www.ace.aaa.com/membership/my-membership/membership-faq.html?area=vanity_servicefee&devicecd=PC#faqServiceFees"
        sx={{ textDecoration: 'none' }}
      >
        AAA.com/servicefee.
      </Link>
    </Typography>
  </Box>
);
